import { Injectable } from "@angular/core";

import { catchError, Observable, throwError } from "rxjs";

import { BaseHttpService } from "@shared/services/base-http.service";

export interface UploadResponse {
  attachmentIds: { id: string; filename: string }[];
}

@Injectable({
  providedIn: "root"
})
export class FileUploadService extends BaseHttpService {
  override baseEndpoint = "files";

  uploadFiles(files: File[]): Observable<UploadResponse> {
    if (!files || files.length === 0) {
      return throwError(() => new Error("No files to upload"));
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });

    return this.post<UploadResponse>({
      endpoint: "upload",
      body: formData
    }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
}
